import Rishank from '../assets/peoples/Rishank_Devadiga.jpg';
import Sneha from '../assets/peoples/Sneha_Ullal.jpg';
import Nimika from '../assets/peoples/Nimika_Ratnakar.jpg';
import Vineeth from '../assets/peoples/Vineeth_Kumar.jpg';
import Yashasvini from '../assets/peoples/Yashasvini_Devadiga.jpg';
import Sandeep from '../assets/peoples/Sandeep_Devadiga.jpg';
import Veerappa from '../assets/peoples/Veerappa_Moily.jpg';
import sangeethasringeri from '../assets/peoples/sangeethasringeri.png';
import Soundarya from '../assets/peoples/Soundarya_Devadiga.jpg';
import BSSherigar from '../assets/peoples/BSSherigar.jpg';
import Abhin from '../assets/peoples/Abhin_Devadiga.jpg';
import Rajanish from '../assets/peoples/Rajanish_Devadiga.jpg';
import Yashwin from '../assets/peoples/Yashwin_Devadiga.jpg';
import Srikanya from '../assets/peoples/srikanya__devadiga.jpg';
import djganesh from '../assets/peoples/djganesh_devadiga.jpg';
import shanu from '../assets/peoples/shanu_babie.jpg';
import varnitha from '../assets/peoples/varnitha-devadiga.jpg';
import kavya from '../assets/peoples/kavya_devadiga_.jpg';
import poojaaa from '../assets/peoples/poojaaa_ashok.jpg';
import Sahana from '../assets/peoples/sahana.jpg';
import deekshaalevoor from '../assets/peoples/deekshaalevoor.jpg';
import GAGAN from '../assets/peoples/GAGAN.jpg';
import ashwini_devadiga from '../assets/peoples/ashwini_devadiga.jpg';
import vshibaroor from '../assets/peoples/vshibaroor.jpg';
import yashaswivd from '../assets/peoples/yashaswivd.jpg';
import vaishu_d_editz from '../assets/peoples/vaishu_d_editz.jpg';
import NishanthDevadiga from '../assets/peoples/NishanthDevadiga.jpg';
import dishadevadiga_ from '../assets/peoples/disha.devadiga_.webp';
import PreethamMN from '../assets/peoples/PreethamMN.jpg';
import rahuldevadiga1997 from '../assets/peoples/rahuldevadiga1997.jpg';
import poojadevadigamusician from '../assets/peoples/poojadevadigamusician.jpg';
import PrakashKarkala from '../assets/peoples/PrakashKarkala.jpg';
import bharathigopal_saxo from '../assets/peoples/bharathigopal_saxo.jpg';
import its_nithinsdevadiga2_official from '../assets/peoples/its_nithinsdevadiga2_official.jpg';
import aisiridevadiga from '../assets/peoples/aisiridevadiga.jpg';
import man from '../assets/peoples/man.jpg';
import SharathDevadiga from '../assets/peoples/SharathDevadiga.jpg';
import DrKvDevadiga from '../assets/peoples/DrKvDevadiga.jpg';
import VeenaDevadiga from '../assets/peoples/VeenaDevadiga.jpg';
import supraattii from '../assets/peoples/supraattii.jpg';
import Dharmapala from '../assets/peoples/Dharmapala.jpg';
import Harishsherigar from '../assets/peoples/Harishsherigar.jpg';
import NithyanandaVolakadu from '../assets/peoples/NithyanandaVolakadu.jpg';
import Shruti from '../assets/peoples/Shruti.jpg';
import Nicky from '../assets/peoples/Nicky.jpg';
import udaySherigar from '../assets/peoples/udaySherigar.jpg';
import KLS from '../assets/peoples/KLS.jpg';
import chandru from '../assets/peoples/chandru.jpg';
import am_rutha from '../assets/peoples/Amrutha_Devadiga.jpg';
import Deekshadancer from '../assets/peoples/Deekshadancer.jpg';
import LathaDevadiga from '../assets/peoples/LathaDevadiga.jpg';
import meghana_saligrama from '../assets/peoples/meghana_saligrama.webp';

const instagram = <i className="bi bi-instagram"></i>
const threads = <i className="bi bi-threads"></i>
const facebook = <i class="bi bi-facebook"></i>
const twitter = <i class="bi bi-twitter"></i>
const email = <i className="bi bi-envelope"></i>
const wikipedia = <i className="bi bi-wikipedia"></i>
const youtube = <i className="bi bi-youtube"></i>
const linkedin = <i className="bi bi-linkedin"></i>

// Assume you have an array of people with their details
const people = [
  {
    id: 1,
    name: 'Rishank Devadiga',
    title: 'Indian kabaddi player',
    image: Rishank,
    summary: "Rishank Devadiga is a prominent figure in Indian professional kabaddi, renowned for his exceptional skills and remarkable performances in the Pro Kabaddi League. Born on February 3, 1994, in Santacruz, Mumbai, Rishank is recognized as one of the league's top raiders, garnering immense praise for his consistent and stellar displays. Having graduated in commerce from Chetana Hazarimal Somani College of Commerce and Economics, Rishank Devadiga also represents BPCL in domestic tournaments. Currently residing in Gangolli village, Karnataka, Rishank faced adversity at a young age, losing his father, and now lives with his mother and sister. Rishank's journey in kabaddi commenced at the age of seven when he realized his innate strength compared to his peers, propelling him to embrace kabaddi as a sport. He kickstarted his career playing for the Mumbai district kabaddi team and achieved recognition with Dena Bank, where he was honored as the best player of the tournament. His impressive performances led him to represent Bharat Petroleum and the Maharashtra team before making his mark in the Pro Kabaddi League. Beginning his PKL career with U Mumba, Rishank Devadiga was retained for three seasons. Subsequently, he moved to UP Yoddha, signing significant contracts, including one worth Rs. 1.11 crores for Season 6. Rishank's rise to prominence attracted attention from the Indian National Kabaddi team in 2015. Known for his do-or-die raids, he exhibits exceptional athleticism and maintains top-notch physical fitness, enabling him to overpower opponents effortlessly during raids. Among his notable achievements, Rishank Devadiga led Maharashtra to victory in the Senior National Kabaddi Championship 2017-18 and contributed to India's triumph in the 2018 Kabaddi Masters title in Dubai. Holding the seventh spot in the all-time raid points list with 449 points in 80 matches, his outstanding performance in Season 3 for U Mumba, securing 115 points in 16 matches, remains a standout accomplishment. Rishank Devadiga's dedication, hard work, and remarkable talent have established him as a force to be reckoned with in the world of kabaddi, leaving an indelible mark on the sport's landscape.",
    links: [
      {
        href: 'https://www.instagram.com/rishank007/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/rishankdevadiga777/',
        text: facebook
      },
      {
        href: 'https://twitter.com/rishankdevadiga?lang=en',
        text: twitter
      },
      {
        href: 'mailto:work.rishank@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 2,
    name: 'Sneha Ullal',
    title: 'Indian actress',
    image: Sneha,
    summary: "Sneha Ullal, born on December 18, 1987, is an Indian actress known for her roles in Telugu and Hindi films. Raised in Muscat, Oman, she hails from a background where her father is a Tulu Devadiga from Mangalore. Sneha pursued her education at Indian School Wadi Kabir and Indian School, Salalah in Oman before moving to Mumbai, where she attended Durelo Convent High School and Vartak College. She made her debut in Bollywood with the 2005 film 'Lucky: No Time for Love' alongside Salman Khan. Noted for her striking resemblance to Aishwarya Rai, this led to her gaining recognition in the industry. Following her Bollywood debut, she ventured into Telugu cinema, gaining success with her role in 'Ullasamga Utsahamga,' which emerged as a significant hit. She further showcased her talents in Telugu movies like 'Nenu Meeku Telusa?' and made a special appearance in the song 'Nuvvu Ready' in the film 'King' opposite Nagarjuna. Afterward, Sneha explored opportunities in Hindi and Telugu films, starring in projects such as 'Simha,' a Telugu blockbuster, and 'Kaashh... Mere Hote' in Hindi. Despite facing ups and downs with various film releases, she earned acclaim for her performance in 'Simha' alongside Balakrishna. Her filmography spans multiple languages, including Hindi, Telugu, Kannada, and English, showcasing her versatility as an actress. Apart from her movie career, Sneha Ullal has also ventured into the digital space with the web series 'Expiry Date,' where she portrayed the character Disha in Telugu and Hindi languages, available on ZEE5. Her journey in the entertainment industry reflects a blend of diverse roles and experiences across various film industries, contributing to her reputation as a talented and versatile actress.",
    links: [
      {
        href: 'https://www.instagram.com/snehaullal/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.threads.net/@snehaullal/?hl=en',
        text: threads
      },
      {
        href: 'https://www.facebook.com/SnehaUllalOfficial/',
        text: facebook
      },
      {
        href: 'https://twitter.com/iamsnehaullal?lang=en',
        text: twitter
      },
      {
        href: 'https://en.wikipedia.org/wiki/Sneha_Ullal',
        text: wikipedia
      },
      {
        href: 'mailto:enquiriesforsneha@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 3,
    name: 'Nimika Ratnakar',
    title: 'Indian model and actress',
    dob: '1 August 1996',
    image: Nimika,
    summary: "Nimika Ratnakar, an Indian model and actress rooted in Mangalore, has carved her niche primarily in Kannada cinema. Her noteworthy contributions in films like 'Mr. Bachelor' and 'Kranti' have garnered attention and acclaim in the industry. Her journey began in the realm of music, initially as a playback singer for various Tulu films, notably lending her voice to 'Madipu,' a film that earned recognition with national and state awards. Nimika Ratnakar made her debut in the Kannada film industry with 'Raama Dhanya' in 2018, marking the beginning of her acting career. Subsequently, she ventured into significant projects, including 'Abbara' and 'The Fighter Suman' in 2022, the latter being a Hindi film. It was in 2023 when Nimika Ratnakar rose to prominence, particularly for her impactful role in the film 'Kranti,' starring Darshan. Her portrayal and the song 'Pushpavati' gained her significant attention and popularity. Her filmography in 2023 boasts additional projects such as 'Trishulam,' 'Mr. Bachelor,' and the already mentioned 'Kranti,' showcasing her versatility and dedication across multiple films. Nimika Ratnakar's journey reflects her diverse talents, from playback singing to making a mark in Kannada and Hindi cinema, portraying varied roles and leaving an indelible mark in the entertainment industry.",
    links: [
      {
        href: 'https://www.instagram.com/nimikaratnakar/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.threads.net/@nimikaratnakar',
        text: threads
      },
      {
        href: 'https://www.facebook.com/nimikaratnakar/',
        text: facebook
      },
      {
        href: 'https://twitter.com/nimikaratnakar?lang=en',
        text: twitter
      },
      {
        href: 'https://en.wikipedia.org/wiki/Nimika_Ratnakar',
        text: wikipedia
      },
      {
        href: 'mailto:nimsratna@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 4,
    name: 'Veerappa Moily',
    title: 'Former Chief Minister of Karnataka',
    image: Veerappa,
    summary: "Marpadi Veerappa Moily, an eminent Indian politician affiliated with the Indian National Congress, hails from Karnataka and has held several prominent positions in government and politics. Born on January 12, 1940, Moily has been a pivotal figure in the political landscape of Karnataka and India. Moily's political journey began in Karnataka, where he became the Chief Minister of the state from November 19, 1992, to December 11, 1994, notably marking the first ethnic Tuluva Chief Minister. He represented the Karkala constituency of Udupi district in the Karnataka state legislative assembly. His tenure as a Member of Parliament included representing the Chikballapur constituency in the Lok Sabha from 2009 to 2019, where he served the nation as Minister of Petroleum and Natural Gas, Corporate Affairs, and Power. Apart from his significant political roles, Veerappa Moily is a distinguished lawyer, and in 2014, he established Moily Law Associates, showcasing his legal expertise beyond politics. Moily's contributions span across various domains, including his involvement in pivotal committees formed by the Indian government. His extensive involvement in reforms, ranging from tax reforms to revenue and administrative reforms in Karnataka, underscores his dedication to economic betterment and governance. His multifaceted career extends beyond politics and law into literature and academia. Moily is a prolific author in Kannada, having penned several notable literary works, including novels, plays, anthologies of poems, and insightful musings on contemporary issues. Notably, his novel 'Thembare' received critical acclaim and has been translated into English under the title 'The Edge of Time.' Moreover, his literary accomplishments are complemented by his ongoing work on an epic poem centered on Draupadi, further showcasing his ceaseless literary pursuits. Veerappa Moily's remarkable journey encompasses a spectrum of roles, from leading Karnataka's economic reforms to contributing significantly to Indian literature, politics, and governance. His dedication, versatility, and wide-ranging expertise continue to shape Karnataka's political landscape and India's socio-economic discourse."
  },
  {
    id: 5,
    name: 'Dr B.S Sherigar',
    title: 'Ex. Vice-Chancellor, Kuvempu University, Shimoga.',
    image: BSSherigar,
    summary: "Professor B.S. Sherigar, an esteemed academician, has been appointed as the new chancellor of Kuvempu University, as officially announced by Governor TN Chaturvedi. Born in 1945, Prof. Sherigar is a distinguished figure in the academic realm, specifically renowned for his expertise in the Department of Industrial Chemistry at the University. His academic journey includes earning an M.Sc. in Physical Chemistry from the University of Mysore, followed by a Ph.D. in Organic Physical Chemistry from Mangalore University. Additionally, he pursued further research, obtaining a Ph.D. from Wichita University in the USA, and has actively contributed to numerous national and international scientific journals, with over 100 of his peer-reviewed articles published to date. Professor Sherigar's scholarly achievements and extensive contributions to the field of chemistry have established him as a prominent figure in academia. With his wealth of knowledge and academic prowess, his appointment as the chancellor of Kuvempu University promises to bring forth a new era of academic excellence and leadership to the institution."
  },
  {
    id: 6,
    name: 'Dharmapal Devadiga',
    title: 'MD at SSIS Engineers',
    image: Dharmapala,
    summary: "Dharmapal U Devadiga, the reelected president of Akhila Bharatha Tulu Okkoota, is a dedicated and influential figure known for his commitment to promoting Tulu culture and heritage. With a strong leadership style, he has demonstrated his ability to steer the organization toward its goals. Devadiga's welcoming demeanor and adeptness in compering events highlight his role as a unifying force within the Tulu community.",
    links: [
      {
        href: 'https://www.linkedin.com/in/dharmapal-devadiga-40791859',
        text: linkedin
      }
    ]
  },
  {
    id: 7,
    name: 'Harish Sherigar',
    title: 'Producer and Dubai-based businessman',
    image: Harishsherigar,
    summary: "Harish Sherigar, a Dubai-based businessman and accomplished movie producer, gained recognition through his notable productions like the 2017 Kannada film 'March 22' directed by Kodlu Ramakrishna and 'Yaanaa' in 2019. Renowned for his philanthropy, Sherigar has earned praise and accolades both in India and overseas for his multifaceted engagements in various disciplines. Recently, he was honored with the Gadinada Ratna Award at a grand felicitation event organized by the Karnataka Devadigara Sangha, recognizing his significant contributions and leadership qualities. Sherigar, alongside his wife Sharmila, was lauded for their accomplishments, with esteemed personalities from different Devadiga Sanghas joining the celebration. His humility, dedication to hard work, and emphasis on commitment rather than seeking awards were highlighted in his inspiring speech during the event. Sherigar's impact extends beyond business and cinema, making him a respected figure in philanthropy and societal endeavors.",
    links: [
      {
        href: 'https://www.instagram.com/harishsherigar/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/harishsherigar66/',
        text: facebook
      }
    ]
  },
  {
    id: 8,
    name: 'Nithyananda Volakadu',
    title: 'Social Worker',
    image: NithyanandaVolakadu,
    summary: "Nityananda Volakadu is a dedicated social worker known for his unique and attention-grabbing protest methods to draw attention to civic issues. His recent demonstration involved performing rituals like 'Arathi' and 'Urulu Seve' to highlight the deplorable condition of the road near the Indrali bridge on the Udupi-Manipal national highway. Volakadu's outspokenness and call for action from higher authorities reflect his commitment to addressing community concerns and ensuring better infrastructure for the public's safety and convenience.",
    links: [
      {
        href: 'https://www.facebook.com/nithyananda.volakadu',
        text: facebook
      }
    ]
  },
  {
    id: 9,
    name: 'Dr Kv Devadiga',
    title: 'Consultant Neurosurgeon - Neuro Clinic',
    image: DrKvDevadiga,
    summary: "Dr. K V Devadiga is a highly esteemed Neurosurgeon based in K S Rao Rd, Mangalore, renowned for his expertise and trusted by numerous locals in the area. As a Consultant Neurosurgeon at Neuro Clinic in Mangaluru, Karnataka, India, Dr. Devadiga brings extensive experience and serves as a Professor of Neurosurgery at Kasturba Medical College, Mangalore. His dedication to neurosurgical care has earned him widespread recognition and trust within the community.",
    links: [
      {
        href: 'https://www.linkedin.com/in/kv-devadiga-317298101/?originalSubdomain=in',
        text: linkedin
      }
    ]
  },
  {
    id: 10,
    name: 'Vineeth Kumar',
    title: 'Indian Actor',
    image: Vineeth,
    summary: "Vineeth Kumar is a versatile actor known for his roles in Kannada and Tulu films. He showcases his talent and artistry in the cinematic realms of both languages. Additionally, Vineeth is associated with @vaibhav_events_adz, specializing in event management across various occasions. Moreover, he collaborates as a partner with @mangopickleentertainment.",
    links: [
      {
        href: 'https://www.instagram.com/vineeth.kumar.a/',
        text: instagram
      },
    ]
  },
  {
    id: 11,
    name: 'Yashasvini Devadiga',
    title: 'Fashion Model',
    image: Yashasvini,
    summary: "Yashasvini Devadiga, a young and talented model from Mangaluru, recently clinched the prestigious 'Miss Teen India 2023 Super Globe' first runner-up title at a captivating beauty pageant held in Hyderabad. Her remarkable achievement has secured her a spot to represent India in the forthcoming global finals to be held in Thailand. Throughout the competition, Yashasvini showcased her prowess and charm in various rounds including introduction, talent, interview, national costume, gown, and question-answer segments. Among the numerous contestants from different parts of the state, Yashasvini stood out magnificently, ultimately claiming the 'Miss Teen India 2023 Super Globe' first runner-up title along with the 'Face of Karnataka 2023' subtitle. Additionally, she secured the 'Miss Teen Mangaluru 2023' first runner-up title, a testament to her exceptional talent and grace. Currently pursuing her II PUC at Govinda Dasa Pre-University College in Surathkal, Yashasvini is an individual driven by her passion for beauty and expression. From her childhood, she has been captivated by the world of pageantry, perceiving it as a platform to voice her unique ideas and showcase her artistic talents. With a strong background in dance, mono-acting, and artistry, she has honed her creative skills and developed a keen eye for fashion and style. Yashasvini attributes her success to her dedication, hard work, and unwavering confidence, traits that have propelled her to this significant stage in her career. Encouraged and supported by her family, especially her parents Devdas Kulai and Meenakshi Devdas, Yashasvini acknowledges their constant backing in nurturing her passions and interests. Expressing her gratitude, she acknowledges the instrumental role played by her director, Naveen Billava, whose guidance and training have been pivotal in her success. Yashasvini remains focused and determined for her upcoming international pageant in Thailand, aiming to make India exceedingly proud on the global stage. Her commitment and consistency underscore her aspiration to shine brightly and leave a lasting impression in the world of beauty and glamour."
  },
  {
    id: 12,
    name: 'Soundarya Devadiga',
    title: 'Fashion Model',
    image: Soundarya,
    summary: "Soundarya Devadiga, a vibrant and ambitious personality hailing from Mangaluru, radiates an unparalleled charm with her enchanting smile and impeccable demeanor. Born into a loving family to (Late) Umesh Devadiga, an entrepreneur, and Mrs. Sharmila Devadiga, a dedicated homemaker, Soundarya has emerged as a rising star in the world of beauty pageants and modeling. Her journey into the limelight commenced with a series of impressive victories in the year 2020, clinching titles such as 'Miss Devadiga 2020' (2nd Runner-Up), 'Miss Tangled 2020', 'Miss Dimple Queen 2020', and 'Face of Heaven Rose 2020'. Soundarya's grace, honesty, and remarkable talent have captivated many, evident in her accomplishments and her engaging persona during interviews, reflecting her innate positivity and honesty. Beyond her striking beauty, Soundarya exhibits intelligence, confidence, and a poised attitude, making her stand out effortlessly. Her sense of fashion reflects her modest and unassuming nature, a quality she attributes to her late father and mother, both pillars of unwavering support throughout her journey. Amidst her academic pursuits, pursuing BBA studies at Besant Women’s College, Soundarya's zest for life extends to various hobbies such as traveling, hiking, dancing, drawing, and acting, showcasing her multifaceted talents and interests. She aspires to be a versatile actor, infusing life and depth into characters, believing that beauty combined with acting skills is a compelling combination essential in the entertainment industry. Driven by ambition, Soundarya remains determined to explore the realms of modeling and acting, expressing gratitude for the opportunities bestowed upon her. Her down-to-earth persona, coupled with her supportive nature and protective stance towards family, defines her character, echoing her sentiments of carrying forward her father's values. With an unwavering passion for modeling and acting, Soundarya envisions herself as a widely successful model and entrepreneur, ready to embrace all opportunities that come her way. Her infectious enthusiasm, confidence, and commitment to living life on her own terms reflect her resilience and determination to carve her niche in the world of glamour and entertainment.",
    links: [
      {
        href: 'https://www.instagram.com/soundarya__devadiga__/',
        text: instagram
      }
    ]
  },
  {
    id: 13,
    name: 'Srikanya Devadiga',
    title: 'Actress',
    image: Srikanya,
    summary: "Srikanya Devadiga, a talented actress, and a recipient of the prestigious Shresta Bala Award, has made a notable mark in the realm of performing arts. With a strong foundation in education, particularly in journalism, she brings a multidimensional perspective to her craft. Her journey as an artist unfolds on the stage, where she gracefully embodies various characters, displaying her prowess in the realm of theater and performing arts. Srikanya's dedication to the stage reflects her passion for the art of storytelling and her commitment to the world of drama. Her love for the theatrical stage transcends boundaries, and her performances resonate with audiences, captivating hearts with every role she undertakes. Srikanya Devadiga's presence in the field of performing arts stands as a testament to her talent, dedication, and deep-seated love for the captivating world of theater.",
    links: [
      {
        href: 'https://www.instagram.com/srikanya__devadiga/',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/@srikanyadevadigatuluvlogs',
        text: youtube
      },
    ]
  },
  {
    id: 14,
    name: 'Sangeetha Sringeri',
    title: 'Indian actress and model',
    image: sangeethasringeri,
    summary: "Sangeetha Sringeri is a talented Indian actress and model, born on May 13, 1996, in Sringeri, Karnataka, India. She gained popularity for her role as Sathi/Parvatii in the Kannada daily soap 'Hara Hara Mahadeva.' Sangeetha has showcased her versatility by participating in various reality shows, including Bigg Boss Kannada (season 10), where she emerged as the 2nd runner-up in 2023. Apart from her successful television career, she has made a mark in the Kannada film industry with notable roles in films like 'A+' (2018) and '777 Charlie' (2022), where she starred opposite Rakshit Shetty. Sangeetha Sringeri's achievements include being ranked as the 3rd Most Promising South Actress of 2022 and winning the Best Actress – Kannada award at the 21st Santosham Film Awards in 2022 for her role in 'Lucky Man.'",
    links: [
      {
        href: 'https://www.instagram.com/iamsangeethasringeri/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/OfficialSangeethasringeri/',
        text: facebook
      },
      {
        href: 'https://twitter.com/sangeethaSring',
        text: twitter
      },
      {
        href: 'https://www.youtube.com/channel/UCxi9YLssi-fw-qEuyJVpgYQ',
        text: youtube
      }
    ]
  },
  {
    id: 15,
    name: 'Shanu Devadiga',
    title: 'Video Creator',
    dob: 'October 3',
    image: shanu,
    summary: "Shanu Devadiga, a prolific video creator hailing from Sirsi, is a dynamic content creator known for her engaging and diverse content. Born on October 3, her creative endeavors span various platforms, notably showcasing her talent on Moj with the handle @shaanudevadiga. With a knack for captivating storytelling and an innovative approach to video creation, Shanu enthralls audiences with her unique and compelling content, making her a sought-after creator in the digital sphere.",
    links: [
      {
        href: 'https://www.instagram.com/shanu_babie/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.threads.net/@shanu_babie',
        text: threads
      },
    ]
  },
  {
    id: 16,
    name: 'ಶ್ರೀ ಚಂದ್ರು ದೇವಡಿಗ ಎಸಳೆ',
    title: 'BJP District Secretary',
    image: chandru,
    summary: "Meet Sri Chandru Devadiga, the dedicated BJP District Secretary who has been entrusted with the responsibility of overseeing the party's activities in the district. His successful tenure has led to his appointment today as the District Vice President of BJP.",
    links: [
      {
        href: 'https://www.facebook.com/chandru.yesale',
        text: facebook
      }
    ]
  },
  {
    id: 17,
    name: 'Kateel Lingappa Sherigar',
    title: 'Asthana Nadaswara vidhwan',
    image: KLS,
    summary: "Meet Kateel Lingappa Sherigar, the Asthana Nadaswara Vidwan at the renowned Kateel Shri Durgaparameshwari Temple. 🎶 Experience his divine melodies echoing through the temple, adding to the spiritual ambiance of this sacred place. 🙏",
    links: [
      {
        href: 'https://www.facebook.com/kateellingappa.sherigar',
        text: facebook
      }
    ]
  },
  {
    id: 18,
    name: 'Pooja Ashok Moily',
    title: 'Actress',
    image: poojaaa,
    summary: "Pooja Ashok Moily, an actress recognized for her talent and versatility, has made significant contributions in the entertainment industry. Her notable roles include portraying Ashwini Divekar in @kaavyaanjaliofficial on @colorsmarathi and featuring in productions like #laganchibedi and #beingnatasha on @star_pravah. With a strong presence in South Indian entertainment, Pooja's performances resonate with audiences, showcasing her skillful portrayal of diverse characters and establishing her as a prominent figure in the industry. #southindiangirl",
    links: [
      {
        href: 'https://www.instagram.com/poojaaa_ashok/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.threads.net/@poojaaa_ashok',
        text: threads
      },
      {
        href: 'https://www.youtube.com/@poojamoily3559',
        text: youtube
      }
    ]
  },
  {
    id: 19,
    name: 'Sahana',
    title: 'Singer',
    image: Sahana,
    summary: "Sahana is a talented singer known for her melodious and captivating vocals. Her musical prowess transcends genres, captivating audiences with her enchanting performances. With a gift for delivering emotive and soulful renditions, Sahana's singing talents resonate with listeners, establishing her as a notable figure in the world of music.",
    links: [
      {
        href: 'https://www.instagram.com/princess_of_lord_shiva_/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/Sahana2001',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/@sahanatvs',
        text: youtube
      }
    ]
  },
  {
    id: 20,
    name: 'Deeksha Alevoor',
    title: 'Saxophonist',
    image: deekshaalevoor,
    summary: "Deeksha Devadiga Alevoor, a professional saxophonist based in Udupi, Karnataka, India, boasts expertise in the realm of music. Her service area spans the vibrant landscape of Udupi, where she enthralls audiences with her skilled and melodious performances on the saxophone. Deeksha's musical talent and dedication position her as a revered figure, offering captivating musical experiences within her service area, enchanting audiences with her soulful renditions and musical artistry.",
    links: [
      {
        href: 'https://www.instagram.com/deekshaalevoor/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/alevoordeeksha/',
        text: facebook
      },
      {
        href: 'https://www.facebook.com/alevoordeeksha/',
        text: twitter
      },
      {
        href: 'https://www.youtube.com/channel/UCvqNa4SpN1wvT9NstseW7Dg',
        text: youtube
      },
      {
        href: 'mailto:deekshadevadiga1993@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 21,
    name: 'Gagan Ravindra Devadiga',
    title: 'Artist',
    image: GAGAN,
    summary: "Gagan Ravindra Devadiga is a distinguished actor, recognized for his contributions to the entertainment industry. With a notable presence in the acting realm, Gagan captivates audiences with his performances, displaying versatility and talent across various roles. His dedication to the craft of acting positions him as a notable figure within the entertainment sphere, leaving a lasting impact with his on-screen presence and memorable portrayals."
  },
  {
    id: 22,
    name: 'Ashwini Devadiga',
    title: 'News Anchor',
    image: ashwini_devadiga,
    summary: "Ashwini Devadiga is a prominent news personality and a recognized face in the field of journalism, best known for her role as a news anchor at @powertvnews. She is the founder and CEO of @colour_candies_by_ashwini, showcasing her entrepreneurial skills. Alongside her successful career, Ashwini is a fashion enthusiast and a journalist, embodying versatility and dedication in her pursuits.",
    links: [
      {
        href: 'https://www.instagram.com/ashwini_devadiga_official/',
        text: instagram
      },
    ]
  },
  {
    id: 23,
    name: 'Vijayalakshmi Shibaroor',
    title: 'Special investigative correspondent',
    image: vshibaroor,
    summary: "Vijayalakshmi Shibaroor, an accomplished investigative correspondent associated with the Vaicom18 network, is renowned for her impactful contributions in the realm of investigative journalism. Born on April 3, 1979, in Shibarooru village near Mangalore, Vijayalakshmi pursued her post-graduation in Mass Communication and Journalism from Mangala Gangotri at Mangalore University. Her academic background laid a strong foundation for her successful career in the media industry. Vijayalakshmi commenced her professional journey as an editor at Janavahini newspaper, swiftly transitioning to Akashvani as a program producer. Her one-year stint at the radio broadcaster was followed by an influential tenure at Samyukta Karnataka, where she took charge of Sapthahika, the supplement of the publication. Her foray into the realm of television began as a senior reporter and anchor at TV9 (Kannada), where she garnered experience and expertise for four years. She later joined ETV Kannada, contributing significantly before assuming the role of Managing Director at Vijaya Times. Notably, Vijayalakshmi has been an instrumental figure in producing the investigative program 'Cover Story.' This program has been pivotal in uncovering a multitude of pressing social issues, shedding light on matters like adulterated food, bonded child labor, and various scams. Her investigative prowess exposed significant scams including lottery scams, betting scams, play home scams, water scams, Anganwadi scams, and food scams through her impactful program. Apart from her contributions to television, Vijayalakshmi has also made substantial strides in print media. Her roles encompassed serving as a magazine editor and holding responsibilities as the general desk in-charge. Her notable works and dedication to investigative journalism have solidified her reputation as a meticulous and dedicated professional. Vijayalakshmi Shibaroor stands as a beacon in the field of journalism, known for her relentless pursuit of truth and her invaluable contributions to the media landscape in India."
  },
  {
    id: 24,
    name: 'YASHASWI',
    title: 'Actor',
    image: yashaswivd,
    summary: "Yashaswi Devadiga, an accomplished actress from Kanwatheerta near Talapady, Mumbai, epitomizes talent and versatility in the entertainment industry. With a journalism background, she transitioned seamlessly into the glamour world, marking her success as a model and actress. Graduating in journalism laid the foundation for Yashaswi's journey, where she swiftly gained recognition in the modeling sphere. Her accolades include winning Miss Mumbai 2017 and various other titles like Miss Fresh, Miss Fab Pune, and Miss Beautiful Smile, showcasing her multifaceted talent. Stepping into the world of acting, Yashaswi featured in the popular television series 'Tarak Mehta Ka Ulta Chasma' on Sab TV. Her foray into the Tulu movie industry began with her debut in 'Belchappa' in 2018, followed by notable appearances in music videos. Yashaswi's upcoming movie, 'Paper Student,' promises to unveil her acting prowess in a unique character, described as someone both straightforward and protective, sweet yet strong-willed. Her admiration for the script's depth and the director's vision led her to eagerly embrace this new role. Her dedication to her craft and her ability to embody diverse characters have captivated audiences. Supported by her family's unwavering encouragement, Yashaswi looks forward to the release of 'Paper Student' and a Sindhi web series titled 'Wedding Bells 2.' Scheduled for release on December 23, 'Paper Student' is set to showcase Yashaswi Devadiga's remarkable talent and storytelling finesse."
  },
  {
    id: 25,
    name: 'Vaishak Devadiga',
    title: 'Actor',
    image: vaishu_d_editz,
    summary: "Vaishak Devadiga, a spirited and enthusiastic individual, is recognized for his multifaceted persona in the entertainment industry. As an actor, he shines with his talent and dedication, captivating audiences with his performances on screen. Born on November 3, he exudes passion and determination in all his endeavors. Vaishak is known for his involvement and victory in the Winners Tug of War with the Bajarangi Boys in Kodical. Beyond his acting pursuits, he holds a fervent love for fitness and the gym, showcasing his commitment to a healthy lifestyle. His diverse skill set also extends to his role as a bouncer, where his strength and prowess ensure safety and security in various environments. With a vibrant spirit and dedication to his craft, Vaishak Devadiga continues to make a mark in the entertainment industry, embodying resilience and enthusiasm in every aspect of his life."
  },
  {
    id: 26,
    name: 'Nishanth Devadiga',
    title: 'Video creator',
    image: NishanthDevadiga,
    summary: "Nishanth Devadiga is a multifaceted individual known for his skills in video creation, hailing from India and the UAE. With an MBA degree from @sdm_mba_, he ventures into the realm of content creation and video editing, showcasing his talent through @ni2h_creation. As a Dance Trainer at @urban_groovee, Nishanth shares his passion for dance, emphasizing movement and expression. His love for exploring new destinations fuels his wanderlust, reflecting his penchant for travel and adventure. Engaging audiences through his YouTube channel, Nishanth captivates viewers with his creative endeavors and diverse content. Follow the link below to explore his captivating world of videos and creative productions."
  },
  {
    id: 27,
    name: 'Disha Devadiga',
    title: 'Musician/band',
    image: dishadevadiga_,
    summary: "Disha Devadiga is a talented artist known for her contributions to the music scene. As a versatile musician or member of a band, her artistic endeavors captivate audiences with soulful melodies and captivating performances. Her passion for music shines through her artistic expressions, establishing her as a noteworthy figure in the music industry.",
    links: [
      {
        href: 'https://www.instagram.com/disha.devadiga_/',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/@dishadevadiga3623',
        text: youtube
      }
    ]
  },
  {
    id: 28,
    name: 'Preetham MN',
    title: 'Actor',
    image: PreethamMN,
    summary: "Preetham MN, a versatile artist, has left an indelible mark in the vibrant realms of Tulu and Kannada cinema. Renowned for his compelling performances as an actor in both film industries, he stands as a prominent figure in the entertainment world. Beyond his acting prowess, Preetham wears multiple hats as a multifaceted entrepreneur, serving as the Owner/Partner at INBOX Creatives and Travel Space. His entrepreneurial ventures reflect his creativity and business acumen, showcasing his ability to excel in diverse domains. Having pursued his education at Mangalore University, Preetham's roots lie in the culturally rich city of Mangalore. Presently residing in Bangalore, India, he has carved a niche for himself in the entertainment industry while maintaining a strong connection to his hometown. Married since May 5, 2003, Preetham MN is not only an accomplished actor but also a dedicated family man. His extensive array of talents encompasses acting, producing, event planning, modeling, and more, portraying his dynamic presence across various facets of the entertainment world. As a passionate traveler and performer, Preetham's journey continues to inspire as he embraces new roles, shapes memorable performances, and contributes significantly to the realms of cinema and entertainment, marked by his notable presence in the acclaimed Kanyakumari serial.",
    links: [
      {
        href: 'https://www.instagram.com/preetham_m_n_/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/mnpreeth',
        text: facebook
      },
      {
        href: 'https://twitter.com/preethammn',
        text: twitter
      },
      {
        href: 'https://www.youtube.com/@mnpreeth',
        text: youtube
      }
    ]
  },
  {
    id: 29,
    name: 'Rahul Devadiga',
    title: 'Musician/band',
    image: rahuldevadiga1997,
    summary: "Rahul Devadiga, a multifaceted individual, navigates seamlessly between the worlds of music and engineering. As a Mechanical Engineer by profession, he brings technical expertise and innovation to his craft. However, his true passion lies in music, where he thrives as a talented musician and a pivotal member of several bands. Rahul stands as a driving force behind the production house, 13 Wonder Creations, showcasing his creative abilities in content creation and production. As a skilled guitarist, he lends his musical talents to bands like Shortheband and Band Aurum, enriching their soundscapes with his expertise and artistry. Notably, Rahul Devadiga has made significant contributions to platforms like Josh Talks, sharing his insights and experiences. His dedication to music, complemented by his engineering background, exemplifies his diverse skill set and his ability to excel in both the technical and artistic spheres. His impactful presence and performances, as highlighted in platforms like Josh Talks, resonate with audiences, showcasing his passion, dedication, and unwavering commitment to both music and engineering. You can find more about his journey and musical prowess on his Josh Talks video: youtu.be/4eomqQLgO4U",
    links: [
      {
        href: 'https://www.instagram.com/rahuldevadiga1997/?hl=en',
        text: instagram
      }
    ]
  },
  {
    id: 30,
    name: 'Pooja Devadiga',
    title: 'Saxophonist',
    image: poojadevadigamusician,
    summary: "Pooja Devadiga, an accomplished saxophonist artist based in Mumbai, is recognized for her exceptional prowess with the saxophone. Renowned for her melodic performances and musical finesse, Pooja captivates audiences with her soulful renditions and captivating performances on the saxophone. As a professional artist, her skillful command of the instrument transcends boundaries, enchanting listeners with the rich and resonant tones of her music. Her performances evoke emotions and create immersive musical experiences, showcasing her dedication and passion for her craft. Her musical talent continues to mesmerize audiences, making her a sought-after saxophonist artist in the vibrant cultural landscape of Mumbai.",
    links: [
      {
        href: 'https://www.instagram.com/pooja_saxophonist/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/poojadevadigamusician/',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/@poojadevadiga9708',
        text: youtube
      },
      {
        href: 'mailto:devadigapooja1997@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 31,
    name: 'Prakash Karkala',
    title: 'Saxophonist',
    image: PrakashKarkala,
    summary: "Prakash Karkala is a distinguished professional saxophonist renowned for his musical expertise. Alongside his musical career, he serves as an Office Superintendent at MITE Moodabidri and was honored as a District Rajyothsava Awardee in 2020 for his exceptional contributions. His educational journey includes studies at GPUC Karkala and Sri Bhuvanendra College, Karkala, followed by attendance at Govt PU College Karkala. Currently residing in Mangalore, his roots trace back to the culturally vibrant town of Karkala. Prakash's mastery of the saxophone coupled with his administrative role reflects a harmonious blend of musical passion and professional commitment. His accolades and musical endeavors exemplify his dedication to both music and community recognition, making him a notable figure in the field of music and education.",
    links: [
      {
        href: 'https://www.instagram.com/prakash.devadiga.562/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/prakash.devadiga.562/',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/c/PrakashKarkala/videos',
        text: youtube
      }
    ]
  },
  {
    id: 32,
    name: 'BharathiGopal',
    title: 'Saxophonist',
    image: bharathigopal_saxo,
    summary: "Bharathi Gopal Sherigar is a multifaceted personality distinguished as a professional saxophonist and acclaimed musician. Her accolades include the prestigious Pride of India Award in 2023, Udupi District Award in 2011, and the Karnataka Yuvaratna Award in 2019, showcasing her exceptional contributions and talent. Aside from her musical achievements, Bharathi has garnered recognition in various domains. Her notable roles as Mahalakshmi in the Kateelu Shri Devi Charithe serial telecasted on DD Chandana highlight her versatility. She also holds titles such as Mrsik Mangalore 2022, Mrsik Udupi District Queen 2022, and the Udupi District Queen at Mrs India Karnataka 2022, where she excelled with awards for Best Walk and Best Photogenic. With a residence in Udupi and roots in Mangalore, Bharathi Gopal Sherigar's remarkable journey intertwines musical excellence, acting prowess, and numerous accolades, solidifying her status as a distinguished figure in both the artistic and cultural spheres.",
    links: [
      {
        href: 'https://www.instagram.com/bharathigopal_saxo/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/bharathigopal.saxo',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/@bharathigopalsaxo6127',
        text: youtube
      }
    ]
  },
  {
    id: 33,
    name: 'Nithin S Devadiga',
    title: 'Personal blogger',
    dob: '02/07/1993',
    image: its_nithinsdevadiga2_official,
    summary: "Nithin S Devadiga, a personal blogger, currently resides in Dubai, hailing originally from Karkala, Udupi. Known for his insightful and engaging content, he shares personal narratives and experiences through his blog. Nithin's writing reflects his unique perspectives, offering a glimpse into his life journey and thoughts, bridging the gap between his roots in Karkala, Udupi, and his current life in Dubai.",
    links: [
      {
        href: 'https://www.instagram.com/its_nithinsdevadiga2_official/',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/@NPcreation02',
        text: youtube
      }
    ]
  },
  {
    id: 34,
    name: 'Aisiri Devadiga',
    title: 'Saxophonist',
    image: aisiridevadiga,
    summary: "Aisiri Devadiga is a skilled and accomplished professional saxophonist. Known for her musical expertise and captivating performances, she showcases mastery over the saxophone, enthralling audiences with her melodic renditions and artistic flair. Aisiri's dedication to her craft has positioned her as a notable figure in the realm of music, captivating listeners with her soulful and enchanting performances as a saxophonist.",
    links: [
      {
        href: 'https://www.instagram.com/aisiridevadiga/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/channel/UCYeDvNhgV0uxJawrvfbrWpQ',
        text: youtube
      }
    ]
  },
  {
    id: 35,
    name: 'Sadashiva Devadiga',
    title: 'SUPV RESEARCH AST, DATA ANALYSIS, NASA',
    image: man,
    summary: "Sadashiva Devadiga is a Physical Scientist in the Terrestrial Information Systems Laboratory at NASA's Goddard Space Flight Center. Devadiga is an expert in the quality assessment of the remote sensed data products and serves as the Quality Assessment Team lead for land and atmosphere products prodced by the data systems in the lab supporting the Terra, Aqua, SNPP and JPSS missions. He has over 20 years of experience in software development for satellite remote sensing data processing and satellite data analysis for major Earth-observing satellite missions and other image processing applications. His specialization include computer vision, artificial intelligence, image processing, pattern recognition, and remote sensed data analysis",
    links: [
      {
        href: 'https://science.gsfc.nasa.gov/earth/terrestrialinfo/bio/sadashiva.devadiga-1',
        text: 'NASA'
      }
    ]
  },
  {
    id: 36,
    name: 'Sharath Devadiga',
    title: 'Actor',
    image: SharathDevadiga,
    summary: "Sharath Devadiga, recognized for his role in the 2021 movie 'Koli Taal,' is an actor who showcased his talent and prowess through this notable film. His performance contributed to the success and acclaim of 'Koli Taal,' solidifying his presence as a skilled actor in the film industry. Sharath's portrayal in the movie resonated with audiences, establishing him as a noteworthy figure in the realm of cinema.",
    links: [
      {
        href: 'https://www.imdb.com/name/nm11294484/',
        text: 'IMDB'
      }
    ]
  },
  {
    id: 37,
    name: 'Veena Devadiga',
    title: 'Saxophonist',
    image: VeenaDevadiga,
    summary: "Veena Devadiga, a talented saxophonist hailing from the serene town of Kundapura. With her soulful melodies and mastery of the saxophone, she creates enchanting music that captivates hearts and transcends boundaries. 🎵✨",
    links: [
      {
        href: 'https://www.facebook.com/profile.php?id=61551819431542',
        text: facebook
      }
    ]
  },
  {
    id: 38,
    name: 'SUPRATI DEVADIGA',
    title: 'Artist',
    image: supraattii,
    summary: "Suprati Devadiga, an esteemed artist based in Mumbai, captivates with her expertise in beauty, fashion, and lifestyle. Through her creative lens, she unveils the essence of elegance, style, and modern living, bringing a unique touch to every creation.  ",
    links: [
      {
        href: 'https://www.instagram.com/supraattii/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.threads.net/@supraattii',
        text: threads
      },
      {
        href: 'https://www.facebook.com/suprati.devadiga.754',
        text: facebook
      },
      {
        href: 'https://www.linkedin.com/in/suprati-devadiga-b85172283',
        text: linkedin
      }
    ]
  },
  {
    id: 39,
    name: 'Abhin Devadiga',
    title: 'Athlete',
    image: Abhin,
    summary: "Abhin Bhaskar Devadiga, a talented athlete hailing from Karnataka, emerged as a sprinting sensation in the world of track and field. His journey to success began with a natural knack for rhythmic coordination, initially honed through drumming. This unique ability translated into a remarkable advantage, enabling him to propel himself forward with unmatched speed and agility on the athletic track. At the prestigious 36th National Junior Athletics Championships held at the Sarusajai Stadium in Guwahati, Abhin showcased exceptional prowess, clinching the under-20 men's 200m gold with a stunning performance, clocking an impressive time of 21.34 seconds. This victory added to his earlier triumph at the Federation Cup Junior U20 Athletics Championships in Bhopal, where he had already secured the title. His sprinting finesse was evident as he tactfully maneuvered the bends, demonstrating strategic running techniques that outpaced his competitors. Notably, Abhin's consistency and swift pace set him apart, securing him a place among the top-tier sprinters in the country. Beyond his exceptional sprinting abilities, Abhin Devadiga's dedication and determination shine through. His commitment to achieving excellence in each race exemplifies his relentless pursuit of success in the field of athletics. As a rising star in the realm of track events, Abhin Bhaskar Devadiga continues to inspire with his remarkable talent and unwavering focus on the path to athletic glory.",
    links: [
      {
        href: 'https://www.instagram.com/abhin_devadiga/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/abhin.udupi',
        text: facebook
      },
    ]
  },
  {
    id: 40,
    name: 'Sandeep Devadiga',
    title: 'Video Creator',
    image: Sandeep,
    summary: "Sandeep Devadiga, a skilled video creator originating from Udupi, seamlessly blends his passion for content creation with his professional role as a Software Engineer at Deloitte. Transitioning between the serene landscapes of Udupi and the bustling tech hub of Bangalore, Sandeep intricately weaves his creative storytelling abilities into his digital content. His journey reflects a harmonious balance between the worlds of technology and artistic expression, making him a notable figure in both realms.",
    links: [
      {
        href: 'https://www.instagram.com/sandeep.devadiga_/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/sandeep.devadiga.9400',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/@CreatorsZone',
        text: youtube
      },
    ]
  },
  {
    id: 41,
    name: 'Rajanish Devadiga',
    title: 'Actor and Film Director',
    image: Rajanish,
    summary: "Rajanish Devadiga, a versatile individual, holds the title of both actor and film director. Renowned for his multifaceted talents, he is recognized for his contributions to the entertainment industry. As an actor, he portrays diverse characters with finesse, while his directorial vision shapes compelling narratives on the silver screen. Rajanish's versatility and dedication have established him as a significant figure in both acting and film direction, showcasing his passion and expertise in the world of cinema.",
    links: [
      {
        href: 'https://www.instagram.com/rajanish_udupi/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/raviudup',
        text: facebook
      }
    ]
  },
  {
    id: 42,
    name: 'Yashwin K Devadiga',
    title: 'Artist',
    image: Yashwin,
    summary: "Yashwin K Devadiga, an artist by title, showcases his creative talent through various forms of artistic expression. With a penchant for creativity, Yashwin brings imagination to life through his artistry. While additional specific details about his expertise or medium of art aren't provided, his title as an artist implies a diverse range of creative endeavors, making a mark through his unique and imaginative expressions within the artistic realm."
  },
  {
    id: 43,
    name: 'Shruti Devadiga',
    title: 'Artist',
    image: Shruti,
    summary: "Shruti Devadiga is a multi-talented artist known for her prowess in various creative domains. As a dancer, model, and assistant director, she brings a unique blend of skills to her work, infusing creativity and precision in every project. Her expertise extends to set dressing, adding depth and aesthetic flair to productions. Additionally, Shruti is a certified Zumba instructor, spreading joy through her vibrant dance routines, and her training in Jazz adds a distinctive style to her performances.",
    links: [
      {
        href: 'https://www.instagram.com/shruti_devadiga7/',
        text: instagram
      }
    ]
  },
  {
    id: 44,
    name: 'Nikhitha (Nicky) Devadiga',
    title: 'Artist',
    image: Nicky,
    summary: "Nikhitha Devadiga, a talented model turned actress, ventured into the world of entertainment after completing her engineering at Srinivas University College of Engineering, Mukka. Before her successful transition to films, she made a mark in the modeling industry, gracing numerous fashion shows with her presence on the runway. Her foray into movies came as a natural progression from her thriving modeling career, and she has since established herself as a prominent figure in the film industry. Alongside her acting endeavors, Nikhitha also owns a clothing brand called @nikis_online, showcasing her diverse talents beyond the silver screen.",
    links: [
      {
        href: 'https://www.instagram.com/nicky.devadiga/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/NickkyDevadiga',
        text: facebook
      }
    ]
  },
  {
    id: 45,
    name: 'Mr . Alevoor Uday Sherigar',
    title: 'Saxophonist',
    image: udaySherigar,
    summary: "Mr. Alevoor Uday Sherigar is a highly skilled saxophonist known for his mesmerizing performances. With a mastery of the saxophone, he captivates audiences with his soulful melodies and versatile playing style. Sherigar's musical prowess and dedication to his craft make him a standout artist in the realm of saxophone performance.",
    links: [
      {
        href: 'https://www.instagram.com/nicky.devadiga/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/NickkyDevadiga',
        text: facebook
      }
    ]
  },
  {
    id: 46,
    name: 'D.J. Ganesh Devadiga',
    title: 'DJ',
    image: djganesh,
    summary: "D.J. Ganesh Devadiga is a talented individual known for his proficiency as a DJ. With expertise in the realm of music mixing and entertainment, he brings electrifying beats and vibrant energy to events and gatherings. Renowned for his skills behind the decks, Ganesh Devadiga captivates audiences with his DJ talent, creating immersive and dynamic musical experiences.",
    links: [
      {
        href: 'https://www.instagram.com/djganesh_devadiga/',
        text: instagram
      },
      {
        href: 'https://www.facebook.com/p/DJ-Ganesh-Devadiga-100063486889865/',
        text: facebook
      },
      {
        href: 'https://www.youtube.com/@djganeshudupi',
        text: youtube
      },
      {
        href: 'mailto:djganesh1072@gmail.com',
        text: email
      }
    ]
  },
  {
    id: 47,
    name: 'Varnitha Devadiga',
    title: 'Video Creator',
    image: varnitha,
    summary: "Varnitha Devadiga is a creative video creator known for her innovative content. With a flair for storytelling and creative expression, she crafts engaging videos that captivate audiences. Varnitha's passion for video creation shines through her work, establishing her as a dynamic and talented content creator in the digital sphere.",
    links: [
      {
        href: 'https://www.instagram.com/varnitha._98/',
        text: instagram
      }
    ]
  },
  {
    id: 48,
    name: 'Kavya Devadiga',
    title: 'Makeup Artist',
    image: kavya,
    summary: "Kavya Devadiga, a proficient makeup artist, excels in the artistry of transforming and enhancing beauty. With a skilled hand and an eye for detail, she brings out the best features in her clients, accentuating their natural charm through makeup. Kavya's expertise and creative flair in the realm of makeup artistry position her as a talented professional dedicated to highlighting and refining individual beauty.",
  },
  {
    id: 49,
    name: 'Amrutha Devadiga',
    title: 'Saxophonist🎷',
    image: am_rutha,
    summary: "Amrutha Devadiga is a gifted saxophonist whose melodies enchant audiences worldwide. With a mastery of the saxophone, she weaves intricate harmonies and soulful tunes that resonate with listeners. Hailing from Karnataka, India, her musical journey reflects a deep appreciation for both classical and contemporary genres. Amrutha's performances evoke emotions and transport listeners to distant realms, making her a standout talent in the world of music.",
    links: [
      {
        href: 'https://www.instagram.com/am_rutha1719/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/@amruthadevadiga226',
        text: youtube
      }
    ]
  },
  {
    id: 50,
    name: 'Deeksha Devadiga',
    title: 'Dancer',
    image: Deekshadancer,
    summary: "Deeksha Devadiga is a talented dancer and a proud recipient of the National Gold Medal in 2019. Hailing from Karnataka, India, she is known for her captivating performances that blend traditional and contemporary styles seamlessly. With a passion for dance deeply rooted in her Kannada heritage, Deeksha has garnered acclaim for her graceful movements and expressive storytelling on stage. As a dedicated artist, she continues to inspire audiences with her artistry and commitment to preserving and evolving her cultural traditions through dance.",
    links: [
      {
        href: 'https://www.instagram.com/_deeksha_devadiga__/?hl=en',
        text: instagram
      }
    ]
  },
  {
    id: 51,
    name: 'Dr. Latha Devadiga',
    title: 'Lecturer',
    image: LathaDevadiga,
    summary: "Dr. Latha Devadiga, a distinguished lecturer within the Department of Oral and Maxillofacial Surgery, brings a wealth of expertise and passion to her role. Armed with a Bachelor of Dental Surgery (B.D.S) qualification, she is dedicated to advancing the field through her commitment to education and clinical practice. Dr. Devadiga's contributions to research and teaching serve as a cornerstone in shaping the future of oral and maxillofacial surgery. With a focus on excellence and innovation, she continues to inspire both colleagues and students alike in her pursuit of enhancing patient care and advancing knowledge in the field.",
    links: [
      {
        href: 'https://www.manipal.edu/mcods-manipal/department-faculty/faculty-list/dr-latha-devdiga.html',
        text: "manipal.edu"
      }
    ]
  },
  {
    id: 52,
    name: 'Meghana Saligrama',
    title: 'Saxophonist 🎷🎷🎷',
    image: meghana_saligrama,
    summary: "Meghana Saligrama, an accomplished saxophonist hailing from Saligrama in Udupi district, is a name synonymous with passion and dedication in the realm of music. Born into a family deeply rooted in musical traditions, Meghana's journey with the saxophone began at a tender age under the guidance of her uncle, Udupi Janardhan, and the renowned saxophonist Alevoor Sunder Sheregar. Her innate talent and relentless practice propelled her swiftly into the limelight, with Meghana astonishing audiences with her mesmerizing performances within a remarkably short span of time. Breaking barriers in a domain where female artists are scarce, Meghana's love affair with the saxophone has not only carved a niche for her but has also garnered widespread acclaim and recognition. Her illustrious career boasts a string of prestigious accolades, including the Kitturu Ranichennamma Award and the Best Musician Award, showcasing her prowess and contribution to the world of music. Meghana's musical virtuosity has transcended boundaries, captivating audiences not only across the nation but also on international stages. Endowed with a multifaceted talent, Meghana is not only a maestro of music but also a sports enthusiast, having showcased her skills in various competitions during her schooling years. Inspired by stalwarts such as the legendary saxophonist Kadri Gopalnath and her mentor, Udupi Janardhan, Meghana continues to push the boundaries of her artistry, constantly striving for excellence. Her discography boasts an impressive array of albums, including \"Meghanada,\" \"Megha Lahari,\" \"Megha Varshini,\" and \"Bhagyada Lakshmi Baaramma,\" each a testament to her musical ingenuity and creativity. Recipient of numerous prestigious titles and awards, Meghana's musical journey is a testament to her unwavering dedication, passion, and unparalleled talent, solidifying her status as one of the foremost saxophonists of her generation.",
    links: [
      {
        href: 'https://www.instagram.com/meghanasaligrama_official/?hl=en',
        text: instagram
      },
      {
        href: 'https://www.youtube.com/@meghanasaligrama6169',
        text: youtube
      },
      {
        href: 'https://www.facebook.com/p/Meghana-saligrama-100045254162525/?locale=hi_IN',
        text: facebook
      }
    ]
  },
  // Add more people 
];

export default people;